import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { STATUS_SUBMITTED } from 'constants/enums/applicationStatuses';
import { RootState } from 'types/state';

/**
 * ProtectedRoute is a rework of Saga Routing, and handles redirection based on
 * the state. When the user isn't authenticated, it goes to '/login'. When the
 * API fails, it goes to '/error'. When the form is locked, it goes to '/locked'.
 * */
const ProtectedRoute: React.FC<RouteProps> = function ({ component: Component, ...rest }) {
  const isAuthenticated = useSelector((state: RootState) => state.authentication.authenticated);

  const hasFetchFormError = useSelector(
    (state: RootState) => state.api.fetchForm.hasError
  );
  const hasFetchFormErrorResponse: string = useSelector(
    (state: RootState): string => get(state.api.fetchForm.response, 'response.data.errors[0].message') || ''
  );
  const hasError = useSelector(
    (state: RootState) => state.api.fetchStatus.hasError
  );

  // Previously we would redirect immediately here, however this has moved to the Landing page functional api.setLockedForm

  if (
    hasFetchFormError
    && isAuthenticated
    && hasFetchFormErrorResponse?.includes?.('Error calling /me/form twice')
  ) {
    return <Redirect to={{ pathname: '/duplicate-session' }} />;
  }

  if ((hasError || hasFetchFormError) && isAuthenticated) { return <Redirect to={{ pathname: '/error' }} />; }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated) {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: {
                  from: props.location.pathname,
                },
              }}
            />
          );
        }

        /*
        // @ts-ignore */
        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;
